import React from 'react';
import clsx from 'clsx';

import { ButtonCustomLinkProps } from './types';
import { ButtonStyle } from './constants';
import { ReactComponent as ChevronSVG } from 'modules/theme/icons/chevrons/chevron-right.svg';
import { ReactComponent as LargeChevronSVG } from 'modules/theme/icons/chevrons/large-chevron-down.svg';
import { ReactComponent as SliceSVG } from 'modules/theme/ims/button-slice.svg';

import styles from './styles.module.scss';

const CustomLink: React.FunctionComponent<ButtonCustomLinkProps> = ({
  ariaLabel,
  children,
  className,
  colour,
  disabled,
  href,
  label,
  onClick,
  style,
  small,
  target,
  title,
}) => {
  const handleMouseDown = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
  };
  const buttonClassName = clsx(
    style && styles.button,
    styles[`${style}`],
    styles[`${colour?.replace(/\s/g, '')}`],
    small && styles.small,
    disabled && styles.disabled,
    className,
  );
  return (
    <a
      aria-label={ariaLabel ? ariaLabel : label}
      className={buttonClassName}
      href={href}
      onClick={onClick}
      onMouseDown={handleMouseDown}
      tabIndex={disabled ? -1 : 0}
      target={target}
      title={title}
    >
      {label && <span>{label}</span>}
      {children}
      {style === ButtonStyle.PRIMARY && (
        <>
          {small ? (
            <ChevronSVG className={styles['chevron']} />
          ) : (
            <LargeChevronSVG className={styles['chevron']} />
          )}
          <SliceSVG className={styles['slice']} />
        </>
      )}
    </a>
  );
};

export default CustomLink;
